import {
    type CreateSubEventResponseType,
    type CreateSubEventRequestType
} from "./type";
import {
    request
} from "../request";

const CreateSubEvent = async (params: CreateSubEventRequestType): Promise<CreateSubEventResponseType> => {
    return await request<CreateSubEventResponseType>("/events/createSubEvent", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateSubEvent;
